import { IProps as IModal, Modal } from 'marketing-site/src/library/elements/Modal'
import {
  CONTENT_TYPE,
  IModal as IContentfulModal,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import React from 'react'
import * as Utils from 'marketing-site/src/library/utils'
import { Entry } from 'contentful'

export function isModal(entry: Entry<any>): entry is IContentfulModal {
  return entry.sys.contentType?.sys.id === 'modal'
}

export const ContentfulModal = (data: IContentfulModal) => (
  <EntryMarker entry={data}>
    <Modal {...transformModal(data)} />
  </EntryMarker>
)

export function transformModal({ fields }: IContentfulModal): IModal {
  const modalContentTypeId = fields.modalComponent.sys.contentType?.sys.id as CONTENT_TYPE
  const modalEntry = fields.modalComponent
  return {
    ...fields,
    backgroundColor: fields.backgroundColor && Utils.getHexColorFromName(fields.backgroundColor),
    renderModalContent: () => renderTransformedComponent(modalContentTypeId, modalEntry),
  }
}
